import { CartItem, ItemOptionType } from '../api';

function calculateBundlePrice(bundle: CartItem) {
  return bundle.items.reduce((acc, item) => {
    const componentProduct = bundle.bundleConfigs?.componentProductData.find(
      (p) => String(p.productId) === String(item.product.productId),
    );
    const componentProductQty = componentProduct?.quantity || 1;

    return (acc + Number(item.product.price)) * componentProductQty;
  }, 0);
}

function mapBundles(cartItems: CartItem[]): CartItem[] {
  const bundles: Record<string, CartItem> = cartItems.reduce((acc, { productBundle, ...item }) => {
    if (!item.product) return acc;

    const bundleId = productBundle?.id;
    const bundle = acc[bundleId];

    const mappedItem = {
      ...item,
      engravingConfigs: bundleId ? null : item.engravingConfigs,
    };

    if (bundle) {
      acc[bundleId] = { ...bundle, items: [...bundle.items, mappedItem] };
    } else {
      acc[bundleId] = {
        ...mappedItem,
        id: bundleId,
        bundleConfigs: productBundle,
        name: productBundle?.title || item.productGrouping.name,
        image: productBundle?.image || item.product.imageUrl,
        size: bundleId ? undefined : item.product.volume,
        identifier: bundleId,
        isBundle: !!bundleId,
        items: [mappedItem],
        bundleExternalId: productBundle?.externalId,
      };
    }

    return acc;
  }, {});

  return Object.values(bundles).filter((value) => {
    return value.isBundle
      ? value.bundleConfigs?.componentProductData.length === value.items.length
      : true;
  });
}

export function calculateSubTotal(cartItems: CartItem[]): number {
  const ENGRAVING_FEE = 50;
  const value: number = mapBundles(cartItems).reduce((acc, bundle) => {
    if (bundle.isBundle) {
      return acc + calculateBundlePrice(bundle) * bundle.items[0].quantity;
    }

    return (
      acc +
      bundle.items.reduce((itemsPrices, item) => {
        const engravingTotal =
          item.itemOptions?.type === ItemOptionType.Engraving ? ENGRAVING_FEE * item.quantity : 0;
        return itemsPrices + engravingTotal + item.product.price * item.quantity;
      }, 0)
    );
  }, 0);

  return Number(value.toFixed(2));
}

export function groupBundleItems(cartItems: CartItem[]) {
  return mapBundles(cartItems).reduce((acc, item) => {
    return item.isBundle
      ? [...acc, { ...item, price: calculateBundlePrice(item) }]
      : [...acc, ...item.items];
  }, []);
}
